import { API_V2 } from '../api';
import {
	Community,
	CommunityWithGroups,
	CreateCommunityRequest,
	UpdateCommunityOrganizationRequest,
} from './CommunityModel';

export function getAllCommunities(): Promise<Community[]> {
	return API_V2.get('/communities')
		.then(({ data }) => data as Community[]);
}

export function getCommunity(id: string): Promise<CommunityWithGroups> {
	return API_V2.get(`/communities/${id}`)
		.then(({ data }) => data as CommunityWithGroups);
}

export function createCommunity(params: CreateCommunityRequest): Promise<CommunityWithGroups> {
	return API_V2.post('/communities', params)
		.then(({ data }) => data as CommunityWithGroups);
}

export async function deleteCommunity(id: string): Promise<void> {
	await API_V2.delete(`/communities/${id}`);
}

export function updateCommunity(id: string, params: CreateCommunityRequest): Promise<CommunityWithGroups> {
	return API_V2.put(`/communities/${id}`, params)
		.then(({ data }) => data as CommunityWithGroups);
}

export function addGroupsToCommunity(id: string, params: string[]): Promise<CommunityWithGroups> {
	return API_V2.put(`/communities/${id}/groups`, params)
		.then(({ data }) => data as CommunityWithGroups);
}

export function removeGroupsFromCommunity(id: string, params: string[]): Promise<CommunityWithGroups> {
	return API_V2.delete(`/communities/${id}/groups`, { data: params })
		.then(({ data }) => data as CommunityWithGroups);
}

export function updateCommunityOrganization(id: string, params: UpdateCommunityOrganizationRequest): Promise<CommunityWithGroups> {
	return API_V2.put(`/communities/${id}/organization`, params)
		.then(({ data }) => data as CommunityWithGroups);
}

export function updateCommunityAdministrators(id: string, params: UpdateCommunityOrganizationRequest): Promise<CommunityWithGroups> {
	return API_V2.put(`/communities/${id}/administrators`, params)
		.then(({ data }) => data as CommunityWithGroups);
}
